import { useEffect, type Dispatch, type SetStateAction } from 'react'
import { answersMapFromResponse } from './survey-answer'
import { initialVisitedQuestionIds } from './survey-navigation'
import type { SurveyDefinition, SurveyDraftAnswer } from './survey-question.types'
import type { ProviderResponseState } from './types'

export function useSurveySessionBootstrap(
  response: ProviderResponseState | undefined,
  definition: SurveyDefinition | null,
  sessionInitialized: boolean,
  setSessionInitialized: (value: boolean) => void,
  setAnswerMap: Dispatch<SetStateAction<Map<string, SurveyDraftAnswer>>>,
  setVisitedQuestionIds: Dispatch<SetStateAction<string[]>>,
  setLocalQuestionId: Dispatch<SetStateAction<string | null>>,
) {
  useEffect(() => {
    if (!response || !definition || sessionInitialized) return
    const byId = new Map(definition.questions.map((q) => [q.id, q]))
    setAnswerMap(answersMapFromResponse(response, byId))
    const startId = response.currentQuestionId ?? definition.questions[0]?.id ?? null
    setVisitedQuestionIds(
      initialVisitedQuestionIds(response.routingPath, response.currentQuestionId, startId),
    )
    if (startId) {
      setLocalQuestionId(startId)
    }
    setSessionInitialized(true)
  }, [
    response,
    definition,
    sessionInitialized,
    setAnswerMap,
    setVisitedQuestionIds,
    setLocalQuestionId,
    setSessionInitialized,
  ])
}
